import CompanyCourse from "@/interfaces/CompanyCourse";
import api from "@/services/api";

interface BulkSendConventionsResponse {
  success: boolean;
  message: string;
  sent: string[];
  errors: Array<{ courseId: string; error: string }>;
}

export const companyCourseConventionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    generateCompanyCourseConvention: build.mutation<
      CompanyCourse,
      [string, string]
    >({
      query: ([companyId, courseId]) => ({
        url: `/companies/${companyId}/courses/${courseId}/conventions`,
        method: "POST",
      }),
      invalidatesTags: (_, __, [companyId]) => [
        "CompanyCourses",
        { type: "CompanyFiles", companyId, id: "LIST" },
      ],
    }),
    sendCompanyCourseConventionForSignature: build.mutation<
      void,
      [string, string, { programmes?: Array<{ label: string; url: string }> }?]
    >({
      query: ([companyId, courseId, body]) => ({
        url: `/companies/${companyId}/courses/${courseId}/conventions/sign`,
        method: "POST",
        body: body ?? {},
      }),
      invalidatesTags: () => [
        "CompanyCourses",
      ],
    }),
    bulkSendConventions: build.mutation<
      BulkSendConventionsResponse,
      [string, { companyCourseIds: string[]; programmes?: Array<{ label: string; url: string }> }]
    >({
      query: ([companyId, body]) => ({
        url: `/companies/${companyId}/conventions/bulk-send`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_, __, [companyId]) => [
        "CompanyCourses",
        { type: "CompanyFiles", companyId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGenerateCompanyCourseConventionMutation,
  useSendCompanyCourseConventionForSignatureMutation,
  useBulkSendConventionsMutation,
} = companyCourseConventionsApi;
